import { useField } from "formik";
import { BaseInputWithLabelProps, InputWithLabel } from "./InputWithLabel";

interface FormikInputProps extends BaseInputWithLabelProps {
  name: string;
  setFieldValue?: (field: string, value: any) => void;
}

export const FormikInputWithLabel: React.FC<FormikInputProps> = ({
  name,
  setFieldValue,
  formatValue,
  ...props
}) => {
  const [field, meta] = useField<string>(name);

  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (formatValue && setFieldValue) {
      let val = (e.target as HTMLInputElement).value;
      let key = e.keyCode || (e as any).charCode;
      if (key === 8) return;
      val = formatValue(val);
      setFieldValue(name, val);
    }
  };

  const hasError = !!(meta.error && meta.touched);

  return (
    <>
      <InputWithLabel
        {...field}
        {...props}
        name={name}
        hasError={hasError}
        errorText={meta.error}
        onKeyUp={onKeyUp}
      />
    </>
  );
};